import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

type ErrorPanelProps = {
  title: string;
  message: string;
  error?: Error | null;
  className?: string;
};

export function ErrorPanel({ title, message, error, className }: ErrorPanelProps) {
  return (
    <div className="flex min-h-[400px] items-center justify-center p-8">
      <Alert
        variant="destructive"
        className={className ?? 'max-w-2xl border-destructive/60 bg-destructive/10 text-destructive'}
      >
        <AlertCircle className="h-5 w-5" />
        <AlertTitle className="text-lg font-semibold">{title}</AlertTitle>
        <AlertDescription className="mt-2 space-y-2">
          <p>{message}</p>
          {error && (
            <details className="mt-4 rounded-md border border-destructive/20 bg-destructive/5 p-3">
              <summary className="cursor-pointer text-sm font-medium">Technical Details</summary>
              <pre className="mt-2 overflow-x-auto text-xs text-destructive/80">
                {error.message || String(error)}
              </pre>
            </details>
          )}
        </AlertDescription>
      </Alert>
    </div>
  );
}

export default ErrorPanel;
